export default "__VITE_ASSET__CuXjjnsc__"